const BASE = '/api';

async function request<T>(path: string, options?: RequestInit): Promise<T> {
  const res = await fetch(`${BASE}${path}`, {
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    ...options,
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({ error: { code: 'UNKNOWN', message: res.statusText } }));
    throw Object.assign(new Error(err.error?.message ?? 'Request failed'), { status: res.status, code: err.error?.code });
  }
  return res.json();
}

export interface SearchParams {
  lat: number;
  lng: number;
  radius?: number;
  date?: string;
  date_end?: string;
  genre?: string | string[];
  page?: number;
  per_page?: number;
}

export function searchEvents(params: SearchParams) {
  const qs = new URLSearchParams();
  qs.set('lat', String(params.lat));
  qs.set('lng', String(params.lng));
  if (params.radius) qs.set('radius', String(params.radius));
  if (params.date) qs.set('date', params.date);
  if (params.date_end) qs.set('date_end', params.date_end);
  if (params.genre) {
    const genres = Array.isArray(params.genre) ? params.genre : [params.genre];
    genres.forEach(g => qs.append('genre', g));
  }
  if (params.page) qs.set('page', String(params.page));
  if (params.per_page) qs.set('per_page', String(params.per_page));
  return request<any>(`/events?${qs}`);
}

export function getEvent(id: string) {
  return request<any>(`/events/${id}`);
}

export function getVenue(id: string) {
  return request<any>(`/venues/${id}`);
}

export function getGenres() {
  return request<{ genres: string[] }>('/genres');
}

export function geocode(address: string) {
  return request<{ lat: number; lng: number; formattedAddress: string }>(
    `/geocode?address=${encodeURIComponent(address)}`
  );
}

export function submitVenueSuggestion(data: {
  name: string;
  address?: string;
  website?: string;
  notes?: string;
  email?: string;
}) {
  return request<{ success: boolean; message: string }>('/venue-suggestions', {
    method: 'POST',
    body: JSON.stringify(data),
  });
}
